import { generateSetChild, generateUpdateArrayChild, generateAddArrayChild } from '@/helpers/VuexHelpers'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		title: '',
		message: '',
		confirm: '',
		cancel: '',
		resolve: null,
		reject: null,
		visible: false,
	},
	actions: {
		showDialog({state, commit}, {title, message, confirm, cancel}) {
			commit('setTitle', {item: title});
			commit('setMessage', {item: message});
			commit('setConfirm', {item: confirm});
			commit('setCancel', {item: cancel});
			commit('setVisible', {item: true});
			return new Promise((resolve, reject) => {
				commit('setResolve', {item: resolve});
				commit('setReject', {item: reject});
      })
		},
		confirmDialog({state, commit}) {
			state.resolve?.(true);
			commit('setVisible', {item: false});
			commit('setResolve', {item: null});
			commit('setReject', {item: null});
		},
		cancelDialog({state, commit}) {
			state.resolve?.(false);
			commit('setVisible', {item: false});
			commit('setResolve', {item: null});
			commit('setReject', {item: null});
		},
	},
	getters: {
		dialogTitle(state) {
			return state.title
		},
		dialogMessage(state) {
			return state.message
		},
		dialogConfirm(state) {
			return state.confirm
		},
		dialogCancel(state) {
			return state.cancel
		},
		dialogVisible(state) {
			return state.visible
		},
	},
	mutations: {
		setTitle: generateSetChild("title"),
		setMessage: generateSetChild("message"),
		setConfirm: generateSetChild("confirm"),
		setCancel: generateSetChild("cancel"),
		setVisible: generateSetChild("visible"),
		setResolve: generateSetChild("resolve"),
		setReject: generateSetChild("reject"),
	}
}
